import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkImportModal = ({ isOpen, onClose, onImport }) => {
  const [file, setFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const fileInputRef = useRef(null);

  if (!isOpen) return null;

  const handleFileSelect = (e) => {
    const selectedFile = e?.target?.files?.[0];
    if (selectedFile && (selectedFile?.name?.endsWith('.xlsx') || selectedFile?.name?.endsWith('.xls'))) {
      setFile(selectedFile);
    }
  };

  const handleImport = async () => {
    if (!file) return;

    setImporting(true);
    setTimeout(() => {
      onImport(file);
      setImporting(false);
      setFile(null);
      onClose();
    }, 2000);
  };

  const handleDownloadTemplate = () => {
    console.log('Downloading Excel template');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card rounded-lg shadow-warm-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            استيراد عقارات من Excel
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-all duration-250"
            aria-label="إغلاق"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-4 md:p-6 space-y-6">
          <div className="bg-muted/50 p-4 md:p-6 rounded-lg border border-border">
            <div className="flex items-start gap-3 mb-4">
              <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
              <div className="text-sm text-muted-foreground">
                <p className="font-medium text-foreground mb-2">تعليمات الاستيراد:</p>
                <ul className="list-disc list-inside space-y-1 mr-4">
                  <li>قم بتحميل قالب Excel أولاً</li>
                  <li>املأ البيانات في الأعمدة المحددة</li>
                  <li>تأكد من صحة جميع البيانات المطلوبة</li>
                  <li>احفظ الملف بصيغة .xlsx أو .xls</li>
                  <li>قم برفع الملف للاستيراد</li>
                </ul>
              </div>
            </div>

            <Button
              variant="outline"
              onClick={handleDownloadTemplate}
              iconName="Download"
              iconPosition="left"
              fullWidth
            >
              تحميل قالب Excel
            </Button>
          </div>

          <div className="border-2 border-dashed border-border rounded-lg p-8 md:p-12 text-center bg-muted/30">
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileSelect}
              className="hidden"
            />

            {!file ? (
              <div className="flex flex-col items-center gap-4">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="FileSpreadsheet" size={32} className="text-primary" />
                </div>

                <div>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
                    رفع ملف Excel
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4">
                    انقر لاختيار ملف Excel
                  </p>
                </div>

                <Button
                  variant="outline"
                  onClick={() => fileInputRef?.current?.click()}
                  iconName="Upload"
                  iconPosition="left"
                >
                  اختيار الملف
                </Button>
              </div>
            ) : (
              <div className="flex flex-col items-center gap-4">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-success/10 flex items-center justify-center">
                  <Icon name="FileCheck" size={32} className="text-success" />
                </div>

                <div>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
                    {file?.name}
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    {(file?.size / 1024)?.toFixed(2)} كيلوبايت
                  </p>
                </div>

                <Button
                  variant="ghost"
                  onClick={() => setFile(null)}
                  iconName="Trash2"
                  iconPosition="left"
                >
                  إزالة الملف
                </Button>
              </div>
            )}
          </div>

          <div className="bg-warning/10 p-4 rounded-lg border border-warning/20">
            <div className="flex items-start gap-3">
              <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
              <div className="text-sm text-warning-foreground">
                <p className="font-medium mb-1">تحذير:</p>
                <p>تأكد من مراجعة البيانات قبل الاستيراد. البيانات غير الصحيحة قد تسبب مشاكل في النظام.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky bottom-0 bg-card border-t border-border p-4 md:p-6 flex items-center justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
          >
            إلغاء
          </Button>
          <Button
            variant="default"
            onClick={handleImport}
            disabled={!file || importing}
            loading={importing}
            iconName="Upload"
            iconPosition="left"
          >
            استيراد
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkImportModal;